<template>
	<el-dialog
	  title="活动需求调查"
	  :visible.sync="dialogVisible"
	  width="30%">
	   <el-form :model="dataForm" ref="dataForm" :rules="rules">
		   <el-form-item label="活动主题" prop="zhutiid" label-width="100px">
			    <el-select v-model="dataForm.zhutiid" placeholder="请选择" clearable style="width:80%;">
			       <el-option
			         v-for="item in zhutiarr"
			         :key="item.id"
			         :label="item.title"
			         :value="item.id">
			       </el-option>
			     </el-select>
		   </el-form-item>
		   <el-form-item></el-form-item>
	   </el-form>
	</el-dialog>
</template>

<script>
	export default {
		data(){
			return{
				dialogVisible:false,
				dataForm:{
					zhutiid:'',//主题id
					beginTime:'',//开始时间
					endTime:'',//结束时间
					address:'',//活动地点 省市区
					addressdetail:'',//详细地址
					price:'',//报名费用 后台发布活动的时候可选 判断是否开启
				},
				rules:{
					zhutiid:[{ required: true, message: '请选择主题', trigger: 'blur' }],
				},
				zhutiarr:[
					{id:1,title:'主题'}
				],
			}
		},
	}
</script>

<style lang="scss">
	
</style>


// WEBPACK FOOTER //
// src/views/notice/components/save.vue